import 'normalize.css';
import './src/styles/global.scss';
import React from 'react';
export const wrapRootElement = ({ element }) => element;
